import { UserProfileUpdate } from "@supernova-studio/model";


export const DTOUserProfileUpdatePayload = UserProfileUpdate;
